import { LINK_TITLE } from '../elements/link'

export const HERO_SIMPLE = `
...on heroSimple_Entry {
  id
  typeHandle

  heading: headingAdvanced { html }

  ${ LINK_TITLE }
}
`
